// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.235",
  "gitHash": "1f0ba7c19a69f16eafe86338cdc372eb60cdc438",
  "versionWithHash": "5.5.235-1f0ba7c19a69f16eafe86338cdc372eb60cdc438"
};
